import getBrandName from "app/shared/utils/BrandHelper";
import FeatureFlags from "app/shared/constants/FeatureFlags";
import useFeatureFlag from "app/shared/hooks/useFeatureFlag";
import AppContants from "app/shared/constants/constants";

// Determine if SMS notifications are enabled based on feature flag
// and current brand is EinsteinBros

function useIsSMSEnabled() {
    const { brandName } = getBrandName();
    const isSMSEnabled = useFeatureFlag(FeatureFlags.EBB_SMS_NOTIFICATION as string);
    return brandName === AppContants.EINSTEIN_APP && isSMSEnabled;
}

export default useIsSMSEnabled;
